import { Navigate, useLocation } from 'react-router-dom'
import useAuth from './useAuth'
import { isAdminUser } from '../lib/adminAuth'
import LoadingSpinner from './LoadingSpinner'

function AdminRoute({ children }) {
  const { isAuthed, user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return <LoadingSpinner message="Loading…" />
  }

  if (!isAuthed) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (!isAdminUser(user)) {
    return <Navigate to="/dashboard" replace />
  }

  return children
}

export default AdminRoute
